import uuidv4 from 'uuid/v4'

import firebase, { firestore } from '../../utils/firebase'
import { openAuthModal } from '../auth/actions'

export const RECEIVED_WHITELISTED_PROPERTIES = 'RECEIVED_WHITELISTED_PROPERTIES'
export const RECEIVED_SAVED_PROPERTIES = 'RECEIVED_SAVED_PROPERTIES'
export const RECEIVED_SAVED_PROPERTY = 'RECEIVED_SAVED_PROPERTY'
export const RECEIVED_UNSAVED_PROPERTY = 'RECEIVED_UNSAVED_PROPERTY'

const savedPropertiesRef = firestore.collection('saved_properties')
const propertiesRef = firestore.collection('properties_for_review')

export const receivedWhitelistedProperties = whitelisted => ({
  type: RECEIVED_WHITELISTED_PROPERTIES,
  whitelisted
})

export const receivedSavedProperties = properties => {
  return {
    type: RECEIVED_SAVED_PROPERTIES,
    properties
  }
}

export const receivedSavedProperty = property => ({
  type: RECEIVED_SAVED_PROPERTY,
  property
})

export const propertyUnsaved = propertyId => ({
  type: RECEIVED_UNSAVED_PROPERTY,
  propertyId
})

export const getSavedProperties = () => {
  return async (dispatch, getState) => {
    const authUser = getState().auth.authUser
    const userId = authUser.id

    const savedPropertiesDocs = await savedPropertiesRef
      .where('userId', '==', userId)
      .get()

    const savedProperties = new Map()

    savedPropertiesDocs.docs.forEach(doc => {
      const savedProperty = doc.data()

      savedProperties.set(savedProperty.propertyId, savedProperty)
    })

    dispatch(receivedSavedProperties(savedProperties))
  }
}

export const clearSavedProperties = () => {
  return async dispatch => {
    dispatch(receivedSavedProperties(new Map()))
  }
}

export const saveProperty = property => {
  return async (dispatch, getState) => {
    const user = getState().auth.authUser

    if (user) {
      const userId = user.id

      const savedProperty = await savedPropertiesRef
        .where('userId', '==', userId)
        .where('propertyId', '==', property.id)
        .get()

      if (!savedProperty.docs.length) {
        const docId = uuidv4()

        const [propertyDoc] = await Promise.all([
          propertiesRef.doc(property.id).get(),

          savedPropertiesRef
            .doc(docId)
            .set({
              userId,
              id: docId,
              propertyId: property.id,
              createdAt: firebase.firestore.FieldValue.serverTimestamp()
            })
        ])

        if (propertyDoc.exists) {
          const property = propertyDoc.data()

          dispatch(receivedSavedProperty(property))
        }

        const address = property.address

        window.analytics.track('saved_property', {
          'property_id': property.id,
          'property_address_display_line1': address.displayLine1,
          'property_city': address.city,
          'property_state': address.state,
          'property_zip': address.zip,
          'property_region_name': address.regionName,
          'property_region_type': address.regionType,
          'property_address': address
        })
      }
    } else {
      dispatch(openAuthModal({
        onSuccess: () => dispatch(saveProperty(property)),
        longSignUpTitle: 'Create an account to save listings',
        longSignInTitle: 'Sign in to save listings'
      }))
    }
  }
}

export const unsaveProperty = property => {
  return async (dispatch, getState) => {
    const user = getState().auth.authUser

    if (user) {
      const userId = user.id

      const savedFirebaseProperties = await savedPropertiesRef
        .where('userId', '==', userId)
        .where('propertyId', '==', property.id)
        .get()

      const savedPropertiesDocs = savedFirebaseProperties.docs

      if (savedPropertiesDocs.length) {
        const savedProperty = savedPropertiesDocs[0].data()
        await savedPropertiesRef.doc(savedProperty.id).delete()
      }

      dispatch(propertyUnsaved(property.id))

      const address = property.address

      window.analytics.track('unsaved_property', {
        'property_id': property.id,
        'property_address_display_line1': address.displayLine1,
        'property_city': address.city,
        'property_state': address.state,
        'property_zip': address.zip,
        'property_region_name': address.regionName,
        'property_region_type': address.regionType,
        'property_address': address
      })
    }
  }
}
